import React, { Component } from "react";
import { observer } from "mobx-react";

import { combineEventFilters } from "@formant/core/common/combineFilters";
import { EventType } from "@formant/core/model/EventType";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IFilter } from "@formant/core/model/IFilter";

import { eventStore } from "../../stores";
import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface IEventTypeSelectProps {
    value: EventType[];
    filter: IEventFilter;
    context: IFilter;
    className?: string;
    onChange: (value: EventType[]) => void;
}

@observer
export class EventTypeSelect extends Component<IEventTypeSelectProps> {
    private eventTypes: EventType[] = [];
    public render() {
        const { value, filter, context, className, onChange } = this.props;
        this.eventTypes =
            eventStore.eventTypes(
                combineEventFilters(context, {
                    ...filter,
                    eventTypes: undefined,
                }),
            ) || this.eventTypes;
        if (allOptions.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && allOptions.length === 1;
        return (
            <MultiSelect
                value={value}
                title="Event type"
                options={allOptions}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}

const allOptions: IMultiSelectOption<EventType>[] = [
    { value: "datapoint-event", label: "Event (legacy)", icon: "event" },
    { value: "triggered-event", label: "Event", icon: "event" },
    {
        value: "intervention-request",
        label: "Intervention",
        icon: "assistance",
    },
    {
        value: "comment",
        label: "Comment",
        icon: "comment",
    },
    {
        value: "annotation",
        label: "Annotation",
        icon: "annotation",
    },
    {
        value: "task-summary",
        label: "Task Summary",
        icon: "task-summary",
    },
    {
        value: "command-request",
        label: "Command request",
        icon: "command",
    },
    {
        value: "command-delivery",
        label: "Command delivery",
        icon: "command",
    },
    {
        value: "command-response",
        label: "Command response",
        icon: "command",
    },
    {
        value: "custom",
        label: "Custom API Event",
        icon: "event",
    },
    {
        value: "teleop-session-record",
        label: "Teleop session",
        icon: "teleop",
    },
    {
        value: "port-forwarding-session-record",
        label: "Port forwarding session",
        icon: "teleop",
    },
    { value: "system", label: "System", icon: "refresh" },
];
